<template>
    <v-card>
        <v-img
                class="white--text"
                height="200px"
                :src="'/static/' + item.img"
                :srcset="'/static/' + item.retina"
        >
        </v-img>
        <v-card-text class="text-xs-left" style="min-height: 209px">
            <h4 class="font-20 book">{{ item.name }}</h4>
            <span class="menu-text book darker-grey">{{ item.job }}</span>
            <span class="menu-text book light-grey">Týden {{ item.week }}</span>
            <p class="regular light-grey pt-2 font-16">
                {{ item.bio }}
            </p>
            <router-link :to="'/vyzyvatel/' + item.alias" class="strong font-16 no-decoration">Zjistit více</router-link>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
      props: ['challenger'],
      computed: {
        item () {
            return this.$store.state.challengers[this.challenger]
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/ChallengerCard.vue